import { RoundedCard } from "shared/UI/RoundedCard/RoundedCard";
import { AccountSecurityModule } from "../../interfaces";
import { useNavigate } from "react-router-dom";
import { ModuleInfoAccordion } from "../ModuleInfoAccordion/ModuleInfoAccordion";
import { useModalContext } from "shared/core/state/ModalContext/ModalContext";
import { trackBtnClicks } from "core/monitoring/Events";
import Button from "shared/UI/Buttons/Button";

export const AccountSecurityModuleCard = ({ cta1, cta2, title, description, info, Icon }: AccountSecurityModule) => {
  const navigate = useNavigate();
  const { isVisible, hide, show } = useModalContext(cta1?.id);
  const { isVisible: isVisible2, hide: hide2, show: show2 } = useModalContext(cta2?.id);

  const handleDismiss = (index: number) => {
    const hideModal = index === 2 ? hide2 : hide;
    const cta = index === 2 ? cta2 : cta1;

    cta?.handleModalDismiss && cta?.handleModalDismiss();
    hideModal();
  };

  const handleClickAction = async (index: number) => {
    const cta = index === 2 ? cta2 : cta1;
    const callback = index === 2 ? show2 : show;

    cta?.eventName && trackBtnClicks(cta?.eventName);
    if (cta?.error) {
      window.location.reload();
    } else if (cta?.onClick) {
      cta.onClick();
    } else if (!cta?.link) {
      callback();
    } else {
      navigate(cta?.link);
    }
  };

  const buttonText = (text: string, loading?: boolean, error?: boolean) => {
    let textValue = text;

    if (loading) {
      textValue = "Loading";
    }

    if (error) {
      textValue = "Try Again";
    }

    return textValue;
  };

  return (
    <>
      <RoundedCard padding="p-0">
        <div className="flex lg:items-center justify-between lg:space-x-10 p-5 lg:p-10 flex-col-reverse lg:flex-row">
          <div className="flex-col justify-between space-y-8 max-w-5xl bg-indigo-500 mt-3 lg:mt-0">
            <div className="flex-1">
              <h2 className="cardTitle">{title}</h2>
              <p>{description}</p>
            </div>

            <div className="mt-8 flex-1 flex flex-col lg:flex-row gap-6">
              {cta1 && (
                <Button
                  className="lg:w-[200px]"
                  disabled={cta1.loading}
                  text={buttonText(cta1.text, cta1.loading, cta1.error)}
                  aria-label={`${title}-${cta1.text}`}
                  onClick={() => handleClickAction(1)}
                  variant={cta1.buttonVariant}
                ></Button>
              )}
              {cta2 && (
                <Button
                  className="lg:w-[200px]"
                  disabled={cta2.loading}
                  text={buttonText(cta2.text, cta2.loading, cta2.error)}
                  aria-label={`${title}-${cta2.text}`}
                  onClick={() => handleClickAction(2)}
                  variant={cta2.buttonVariant}
                />
              )}
            </div>
          </div>
          {Icon && (
            <div data-testid="account-security-module-icon" className="w-20 h-20 lg:w-32 lg:h-32 lg:w-48 lg:h-48">
              <Icon style={{ width: "inherit", height: "inherit" }} />
            </div>
          )}
        </div>
        {info && <ModuleInfoAccordion {...info} />}
      </RoundedCard>
      {cta1?.CtaModal && <cta1.CtaModal isVisible={isVisible} onDismiss={() => handleDismiss(1)} {...cta1.props} />}
      {cta2?.CtaModal && <cta2.CtaModal isVisible={isVisible2} onDismiss={() => handleDismiss(2)} {...cta2.props} />}
    </>
  );
};
